import * as React from "react";
import classnames from "classnames";
import { MediaQuery, Button } from "@grandvisionhq/common";
import { useLink } from "@grandvisionhq/frk-routing";
import { PaymentMethod, ApplePayButton } from "@grandvisionhq/payments";
import { useIntl } from "@grandvisionhq/state";
/* empty css            */
import { StepNames } from "../../../../models/models/shared.js";
const Footer = ({
  onPrevStep,
  onNextStep,
  isPrevStepDisabled = false,
  isNextStepDisabled = false,
  stepName,
  isFirstStep = false,
  selectedPaymentMethod,
  isNextStepHidden = false
}) => {
  const { getLabel } = useIntl();
  const { onClick: navigateToCartPage } = useLink({ route: "cart.overview" }, { replace: true }) || {};
  const breakPoint = MediaQuery.useBreakpoint();
  const handleNextStep = React.useCallback(() => {
    onNextStep();
  }, [onNextStep]);
  return /* @__PURE__ */ React.createElement("div", { className: "checkout-footer" }, /* @__PURE__ */ React.createElement(
    Button,
    {
      variant: "outline",
      size: breakPoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE ? "small" : void 0,
      color: "primary",
      caption: isFirstStep ? getLabel("checkout.actions.backToStore") : getLabel("checkout.actions.previousStep"),
      className: classnames({
        "button--full-width": isNextStepHidden
      }),
      "data-t": `button-previous-${stepName}`,
      disabled: isPrevStepDisabled,
      onClick: isFirstStep ? navigateToCartPage : onPrevStep
    }
  ), !isNextStepHidden && (selectedPaymentMethod === PaymentMethod.APPLE_PAY ? /* @__PURE__ */ React.createElement(
    ApplePayButton,
    {
      type: "regular-checkout",
      onClick: onNextStep,
      isDisabled: isNextStepDisabled
    }
  ) : /* @__PURE__ */ React.createElement(
    Button,
    {
      color: "primary",
      size: breakPoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE ? "small" : void 0,
      caption: stepName === StepNames.Payment ? getLabel("checkout.actions.completeOrder") : getLabel("checkout.actions.nextStep"),
      "data-t": `button-next-${stepName}`,
      disabled: isNextStepDisabled,
      onClick: handleNextStep
    }
  )));
};
export {
  Footer
};
//# sourceMappingURL=Footer.js.map
